import Cookie from "js-cookie";
import { Const } from "../constants";
import * as _ from "lodash";
import jwt from "jwt-decode";
import { clearAllReactiveVars } from "libs/apolloCache";

class AuthHelpers {
    public checkAuthen = (req?: any) => {
        let token, expirationDate;
        /**
         * req: for server site when reloading page
         */
        try {
            token = this.getCookie("jwt", req);
            expirationDate = this.getCookie("expirationDate", req);
            if (!_.isNull(token) && !_.isUndefined(token)) {
                //let user: IUser = jwt(token);
                /*
                  if outside expirationDate
                  or role is not exits in const
                */
                if (new Date().getTime() > +expirationDate) {
                    //!_.find(Const.userRoles, ['id', +user.role])
                    return false;
                }

                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };

    public checkRuleWithLogin = (token: any) => {
        try {
            let user: any = jwt(token);
            if (user) {
                const role = _.isArray(user.role) ? _.min(user.role) : user.role;
                this.setLoginInfo(token);
                return { isLogin: true, role, campagne: user.campagne || null };
            }
            return { isLogin: false, role: [] };
        } catch (error) {
            console.log(error);
            return { isLogin: false, role: [] };
        }
    };

    public getRole = () => {
        let token = this.getCookie("jwt");
        if (token) {
            let token_decoded: any = jwt(token);
            if (token_decoded && token_decoded.role.length > 0) return JSON.parse(_.min(token_decoded.role) ?? "");
        }
        return [];
    }

    public setLoginInfo = (token: string) => {
        if (token) {
            this.setCookie("jwt", token); // for ssr
            /* expirationDate: 24hours */
            this.setCookie("expirationDate", new Date().getTime() + Const.expireDate * 1000);
        }
    };

    private clearCookiesAndReactiveVars = async () => {
        // Clear all auth cookies
        this.removeCookie("jwt");
        this.removeCookie("expirationDate");
        this.removeCookie("campagne");
        
        // Clear reactive variables
        try {
            clearAllReactiveVars();
        } catch (error) {
            console.error("Reactive vars cleanup failed:", error);
        }
    };

    public logout = async () => {
        // Full logout: Clear cookies, reactive vars, AND Apollo cache
        await this.clearCookiesAndReactiveVars();
        
        // Additionally clear Apollo cache for complete cleanup
        try {
            const client = (await import('../libs/apolloClient')).default;
            await client.clearStore();
        } catch (error) {
            console.error("Apollo cache cleanup failed:", error);
        }
        
        return true;
    };

    public getToken(name: string) {
        let token;
        token = localStorage.get(name) || null;
        return token;
    }

    public removeLocalStorage(key: string) {
        localStorage.removeItem(key);
    }

    public setToken(name: string, value: any) {
        localStorage.setItem(name, value);
    }

    public setCookie(name: string, value: any) {
        Cookie.set(name, value);
    }

    public getUserLogin() {
        const token = this.getCookie("jwt");
        const expirationDate = this.getCookie("expirationDate");
        if (new Date().getTime() < +expirationDate && !_.isNull(token) && !_.isUndefined(token)) {
            const userLogin = jwt(token);
            return userLogin;
        }
    }

    public getCookie(name: string, req?: any) {
        let value: any;
        if (req) {
            if (!req.headers.cookie) return;

            const jwtCookie = req.headers.cookie.split(";").find((c: any) => c.trim().startsWith(name + "="));

            if (!jwtCookie) return;
            value = jwtCookie.split("=")[1];
        } else {
            value = Cookie.get(name);
        }

        return value;
    }

    public removeCookie(name: string) {
        Cookie.remove(name);
    }
}

const authHelpersInstance = new AuthHelpers();

export default authHelpersInstance;
